<template>
  <div class="panel-attention">
    <p>
      会議室・ホールの予約および料金や空き状況・スケジュールにつきましては、施設に直接お問い合わせください
    </p>
    <kcs-btn
      :url="detail.url"
      :external="true"
      @click.native="
        handleAnalyticsTrackEvent(
          'facility_detail',
          'click',
          'official_link',
          1
        )
      "
      name="施設へ問い合わせる"
    />
  </div>
</template>

<script>
import KcsBtn from '@/components/atoms/kcs-btn.vue'
export default {
  components: {
    KcsBtn
  },
  props: {
    detail: {
      type: Object,
      required: true
    }
  }
}
</script>
